import { PhoneInTalkOutlineIcon } from './PhoneInTalkOutlineIcon';

/**
 * author: Google
 * id BC90A08C-75FB-4E14-9795-3E408CB021AB
 * name phone-in-talk-outline
 * version: 4.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/phone-in-talk-outline.svg
 * tags
 * - Cellphone / Phone 
 */
export const TelephoneInTalkOutlineIcon = PhoneInTalkOutlineIcon;
export default TelephoneInTalkOutlineIcon